"use client";
import Image from "next/image";
import type { Partner } from "./partners";

interface PartnerCardProps {
  partner: Partner;
}

export function PartnerCard({ partner }: PartnerCardProps) {
  return (
    <div className="flex items-center justify-center p-4 sm:p-6">
      <div className="relative w-full h-24 sm:h-20 md:h-18">
        <Image
          src={partner.logo}
          alt={`Logo di ${partner.name}`}
          fill
          className="object-contain"
          loading="lazy"
        />
      </div>
    </div>
  );
}
